<template>
  <div class="lg:flex flex-1" style="padding-top: var(--nav-height)">
    <LNavComponent v-if="pageName !== 'conferenceListApp'" />
    <appNavigator v-if="pageName === 'conferenceListApp'" :page="pageName" />

    <!--    <LNavComponent v-if=" pageName !== 'memberProfileConferenceApp' " />-->
    <conferencePage />
  </div>
  <conferenceFooter />
</template>

<script>
import LNavComponent from "@/components/new/Nav.vue";
import conferencePage from "@/pages/conferencePage.vue";
import appNavigator from "@/components/appNavigator.vue";
import conferenceFooter from "@/components/new/Footer.vue";

export default {
  name: "conferenceList",
  components: { conferencePage, LNavComponent, appNavigator, conferenceFooter },
  data() {
    return {
      pageName: this.$route.name,
    };
  },
  /*watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        window.location.reload();
      }
    }
  }*/
};
</script>

<style scoped></style>
